var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgListShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#7ac689"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19 9.514a3.4 3.4 0 0 1-1 2.312L15.83 14a3.4 3.4 0 0 1-2.415 1h-.003a3.416 3.416 0 0 1-3.41-3.51.5.5 0 1 1 1 .028 2.415 2.415 0 0 0 3.335 2.3c.293-.122.559-.3.782-.524l2.172-2.172a2.414 2.414 0 0 0-3.414-3.415l-.687.688a.5.5 0 0 1-.707-.707l.687-.688A3.416 3.416 0 0 1 19 9.514m-8.187 6.09-.688.687a2.4 2.4 0 0 1-1.712.708 2.415 2.415 0 0 1-1.706-4.12l2.168-2.173A2.415 2.415 0 0 1 13 12.481a.5.5 0 1 0 1 .028A3.43 3.43 0 0 0 13 10a3.416 3.416 0 0 0-4.829 0l-2.17 2.172A3.414 3.414 0 0 0 10.824 17l.688-.687a.5.5 0 0 0-.7-.709"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListShare);
export default __webpack_public_path__ + "static/media/list-share.ee377e2914cba1e51685e98cc86ebbbb.svg";
export { ForwardRef as ReactComponent };